import { useEffect, useState } from 'react'

export function useCustomDomain() {
  const [isCustomDomain, setIsCustomDomain] = useState(false)

  useEffect(() => {
    const host = window.location.host
    const isCustom = !(
      host.includes('fingertip.com') ||
      host.includes('localhost') ||
      host.includes('127.0.0.1') ||
      host.includes('vercel.app') ||
      host.includes('fngrtp.co')
    )
    setIsCustomDomain(isCustom)
  }, [])

  return { isCustomDomain }
}
